import { isWpsEnv } from './get-user-info';
import { openAppInNewTab } from './wps-fn';

export interface IOpenInNewTabParams {
  url: string;
  appid?: string;
  src?: string;
  extraData?: Record<string, any>;
}

export const openInNewTab = (data: IOpenInNewTabParams) => {
  const { url, appid, src, extraData } = data || {};
  if (!url) {
    return;
  }

  const isWps = isWpsEnv();
  if (isWps && appid) {
    openAppInNewTab(url, appid, src || '', extraData);
  } else {
    window.open(url, '_blank');
  }
};
